const cn = {
  global: {
    home: "首页",
    logout: "退出登录",
    language: {
      chinese: "中文",
      english: "english"
    },
    search: "搜索",
    actions: "操作",
    edit: "编辑",
    create: "新增",
    detail: "详情",
    add: "新增",
    delete: "删除",
    cancel: "取消",
    changePwd: "修改密码"
  },

  breadcumb: {
    changePwd: "修改密码",
  },
  login: {
    title: "石基星支付",
    tips: "English",
    loginBtn: "登录",
    accounts_pass_login: "账号密码登录",
    scan_code_login: "扫码快速登录",
    remember: "记住我",
    register: "注册",
    forget_pass: "忘记密码",
    username_placeholder: "请输入账号或邮箱",
    password_placeholder: "请输入密码",
    verifyCode_placeholder: "请输入验证码",
    username_invaild: "请输入用户名",
    password_invaild: "密码长度不能小于6位"
  },
  register: {
    name: "注册",
    title1: "注册",
    userName: "姓名",
    userEmail: "邮箱",
    verifyCode: "验证码",
    title2: "请设置您的密码",
    password: "密码",
    password2: "确认密码",
    updateInfo: "补充信息",
  },
  resetPwd: {
    name: "重置密码",
    title1: "请输入您的邮箱",
    userEmail: "邮箱",
    verifyCode: "验证码",
    title2: "请重置您的密码",
    password: "密码",
    password2: "确认密码",
  },
  home: {
    name: "首页",
    app_title: "我的应用列表",
    update_log: "更新日志", 
  },
  profile: {
    profile: "个人信息",
    user_name: "用户名称",
    account_id: "用户代码",
    teller_type: "操作员类型",
    expiration_time: "过期时间",
    changePwd: "修改密码",
    old_password: "原密码：",
    new_password: "新密码：",
    confirm_password: "确认密码", 
    new_password_strongth: "新密码强度" 
  },

  user: {
    name: "用户管理"
  },
  role: {
    name: "角色管理"
  },
  operationLog: {
    name: "操作日志"
  },
  setting: {
    name: "系统设置"
  },
  // dashboard: {
  //   name: "首页",
  //   panel_group: {
  //     trans: "流水查询",
  //     hist_trans: "交易明细",
  //     pre_auth_trans: "预授权",
  //     accounts: "自动核账",
  //     count_logs: "系统日志",
  //     count_coupon: "优惠券"
  //   }
  // },

  el: {
    colorpicker: {
      confirm: "确定",
      clear: "清空"
    },
    datepicker: {
      now: "此刻",
      today: "今天",
      cancel: "取消",
      clear: "清空",
      confirm: "确定",
      selectDate: "选择日期",
      selectTime: "选择时间",
      startDate: "开始日期",
      startTime: "开始时间",
      endDate: "结束日期",
      endTime: "结束时间",
      prevYear: "前一年",
      nextYear: "后一年",
      prevMonth: "上个月",
      nextMonth: "下个月",
      year: "年",
      month1: "1 月",
      month2: "2 月",
      month3: "3 月",
      month4: "4 月",
      month5: "5 月",
      month6: "6 月",
      month7: "7 月",
      month8: "8 月",
      month9: "9 月",
      month10: "10 月",
      month11: "11 月",
      month12: "12 月",
      // week: '周次',
      weeks: {
        sun: "日",
        mon: "一",
        tue: "二",
        wed: "三",
        thu: "四",
        fri: "五",
        sat: "六"
      },
      months: {
        jan: "一月",
        feb: "二月",
        mar: "三月",
        apr: "四月",
        may: "五月",
        jun: "六月",
        jul: "七月",
        aug: "八月",
        sep: "九月",
        oct: "十月",
        nov: "十一月",
        dec: "十二月"
      }
    },
    select: {
      loading: "加载中",
      noMatch: "无匹配数据",
      noData: "无数据",
      placeholder: "请选择"
    },
    cascader: {
      noMatch: "无匹配数据",
      loading: "加载中",
      placeholder: "请选择",
      noData: "暂无数据"
    },
    pagination: {
      goto: "前往",
      pagesize: "条/页",
      total: "共 {total} 条",
      pageClassifier: "页"
    },
    messagebox: {
      title: "提示",
      confirm: "确定",
      cancel: "取消",
      error: "输入的数据不合法!"
    },
    upload: {
      deleteTip: "按 delete 键可删除",
      delete: "删除",
      preview: "查看图片",
      continue: "继续上传"
    },
    table: {
      emptyText: "暂无数据",
      confirmFilter: "筛选",
      resetFilter: "重置",
      clearFilter: "全部",
      sumText: "合计"
    },
    tree: {
      emptyText: "暂无数据"
    },
    transfer: {
      noMatch: "无匹配数据",
      noData: "无数据",
      titles: ["列表 1", "列表 2"],
      filterPlaceholder: "请输入搜索内容",
      noCheckedFormat: "共 {total} 项",
      hasCheckedFormat: "已选 {checked}/{total} 项"
    },
    image: {
      error: "加载失败"
    },
    pageHeader: {
      title: "返回"
    }
  }
};
export default cn;



// WEBPACK FOOTER //
// ./src/i18n/langs/cn.js